<script lang="ts">
  import { Calendar } from "lucide-svelte"
  import { formatDate } from "$app/utils"

  let {
    date = $bindable(null),
    onchange,
    onkeydown
  }: {
    date: Date | string | null
    onchange?: (date: string) => void
    onkeydown?: (event: KeyboardEvent) => void
  } = $props()

  if (typeof date === "string") {
    try {
      if (/\d{4}\-\d{2}\-\d{2}$/.test(date)) {
        date = new Date(`${date}T00:00:00`)
      } else if (/\d{4}\-\d{2}\-\d{2}T\d{2}\:\d{2}$/.test(date)) {
        date = new Date(date)
      }
    } catch (e) {
      date = null
    }
  }

  let downedKey: string = $state("")

  const FORMAT_DATE = {
    location: "en-CA",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }

  let inputDate = $state(date ? formatDate(date, "db") : null)
  function handleChanged(event: Event) {
    const newDate = (event.target as HTMLInputElement).value
    if (downedKey === "Backspace" || downedKey === "Delete" || newDate) {
      date = new Date(`${newDate}T00:00:00`)

      inputDate = formatDate(date, "db")
      onchange(formatDate(date, FORMAT_DATE))
    }
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    downedKey = event.key
    onkeydown(event)
  }
</script>

<div
  class="mt-1 px-2 py-2 text-sm rounded-md border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 whitespace-nowrap relative"
>
  <div class="w-full flex items-center justify-between relative">
    <span class="text-sm">{date ? formatDate(date) : "Not Set"}</span>
    <Calendar class="size-5 text-gray-500 mr-1" />

    <input
      type="date"
      class="datepicker-input"
      value={inputDate}
      onchange={handleChanged}
      onkeydown={handleKeyDown}
    />
  </div>
</div>

<style>
  .datepicker-input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    box-sizing: border-box;
  }
  .datepicker-input::-webkit-calendar-picker-indicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
</style>
